export default "__VITE_ASSET__wwuHS6BS__"